import React from 'react';
//import { Accordion, AccordionItem } from 'react-light-accordion';
import 'react-light-accordion/demo/css/index.css';
//import Calendar from './Calendar';



import { Link } from 'react-router-dom'
class Board extends React.Component{
constructor(props){
  super(props);
  this.state ={
    msgs:[],
    isLoading:true,
    }
}







render(){


return(



<div style={{display:'flex', flex:'2 1',justifyContent:'space-evenly', margin:100}}>

<div className="shadow-4" style={{display:'flex', flexDirection:'row', justifyContent:'center', padding:7, backgroundColor:'#678ece'}}>


<div style={{display:'flex', flexDirection:'column'}}>

<Link className="ma2 pa2 br3 shadow-3 grow" to="/add_child" style={{border:'1px solid blue', borderRadius:5,padding:5, width:100, margin:5,color:'white', backgroundColor:'blue', textDecoration:'none'}}>
Add Child
</Link>

<Link className="ma2 pa2 br3 shadow-3 grow bg-green br-green" to="/change_child_details" style={{width:100, margin:5, color:'white',textDecoration:'none'}}>
Change Child Details
</Link>

<Link className="ma2 pa2 br3 shadow-3 grow bg-orange br-orange" to="/child_detail" style={{margin:5, color:'white',textDecoration:'none'}}>
Child Details
</Link>

</div>


<div style={{display:'flex', flexDirection:'column'}}>

<Link className="ma2 pa2 br3 shadow-3 grow" to="/add_class" style={{border:'1px solid blue', borderRadius:5,padding:5, width:100, margin:5,color:'white', backgroundColor:'blue', textDecoration:'none'}}>
Add Class
</Link>

<Link className="ma2 pa2 br3 shadow-3 grow bg-green br-green" to="/change_class_details" style={{width:100, margin:5, color:'white',textDecoration:'none'}}>
Change Class Details
</Link>

</div>



<div style={{display:'flex', flexDirection:'column'}}>

<Link className="ma2 pa2 br3 shadow-3 grow" to="/add_collector" style={{border:'1px solid blue', borderRadius:5,padding:5, width:200, margin:5,color:'white', backgroundColor:'blue', textDecoration:'none'}}>
Add Collector
</Link>

<Link className="ma2 pa2 br3 shadow-3 grow bg-green br-green" to="/change_collector_details" style={{width:200, margin:5, color:'white',textDecoration:'none'}}>
Change Collector Details
</Link>


<Link className="ma2 pa2 br3 shadow-3 grow  bg-orange br-orange" to="/collector_detail" style={{width:200, margin:5, color:'white',textDecoration:'none'}}>
Collector Details
</Link>

</div>

</div>

<div className="shadow-4" style={{display:'flex', flexDirection:'row', justifyContent:'center', padding:7, backgroundColor:'#678ece'}}>

<div style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>

<Link className="br3 ma3 pa3 bg-dark-pink grow br-dark-pink" to="/allergy_detail" style={{width:100, margin:5, color:'white',textDecoration:'none'}}>
Allergies
</Link>

<Link className="br3 ma3 pa3 bg-dark-pink grow br-dark-pink" to="/daily_report" style={{width:100, margin:5, color:'white',textDecoration:'none'}}>
Report
</Link>

<Link className="br3 ma3 pa3 bg-dark-pink grow br-dark-pink" to="/summary" style={{width:100, margin:5, color:'white',textDecoration:'none'}}>
Summary
</Link>

</div>


<div style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>

<Link className="br3 ma3 pa3 bg-orange grow br-orange" to="/view-Indemnities" style={{margin:5, color:'white',textDecoration:'none'}}>
Indemnity Forms
</Link>

<Link className="br3 ma3 pa3 bg-light-purple grow br-light-purple" to="/create-activity-or-event" style={{margin:5, color:'white',textDecoration:'none'}}>
Create Activity/Event
</Link>



<Link className="br3 ma3 pa3 bg-light-purple grow br-light-purple" to="/view-events" style={{margin:5, color:'white',textDecoration:'none'}}>
View Activities/Events
</Link>

</div>

</div>


</div>



)

}


}

export default Board;



// WEBPACK FOOTER //
// ./src/components/DashBoard/Board.js